import { useSubscriptionActiveShiftsPage } from 'src/subscriptions/subscription-active-shifts'
import { useSubscriptionAlertCreated } from 'src/subscriptions/subscription-alert-created'
import { useSubscriptionCompletedReportGeneration } from 'src/subscriptions/subscription-completed-report-generation.ts'
import { useSubscriptionUserNotificationCreated } from 'src/subscriptions/subscription-user-notification-created'

export const useWebsocketSubscriptionLayout = () => {
  useSubscriptionCompletedReportGeneration()
  useSubscriptionActiveShiftsPage()
  useSubscriptionAlertCreated()
  useSubscriptionUserNotificationCreated()

  return {}
}
